import get from 'lodash/get'

const state = {
  customerConfig: null,
}

const getters = {
  customerConfig: (state) => state.customerConfig,
  mapboxglApiKey: (state) =>
    get(state, 'customerConfig._source.mapboxglApiKey', null),
  emails: (state) => get(state, 'customerConfig._source.reports.emails', []),
  externalDashboards: (state) =>
    get(state, 'customerConfig._source.externalDashboards', []),
  quickConnectSlave: (state) =>
    get(state, 'customerConfig._source.quickConnectSlave', false),
  assetViewConfig: (state) =>
    get(state, 'customerConfig._source.assetView', null),
  assetListConfig: (state) =>
    get(state, 'customerConfig._source.assetList', null),
  timezone: (state) =>
    get(state, 'customerConfig._source.timezone', 'Europe/Paris'),
}

const actions = {
  FETCH_CURRENT_CUSTOMER_CONFIG: async ({ commit, rootGetters }, kuzzle) => {
    if (!rootGetters['auth/currentIndex']) {
      return
    }
    let customerConfig = null
    try {
      const res = await kuzzle.document.get(
        rootGetters['auth/currentIndex'],
        'config',
        'config',
      )

      if (res._id) {
        customerConfig = res
        delete customerConfig._source._kuzzle_info
      }
    } catch (error) {
      console.error(error)
      throw error
    }

    commit('SET_CURRENT_CUSTOMER_CONFIG', customerConfig)
  },
}

const mutations = {
  SET_CURRENT_CUSTOMER_CONFIG: (state, config) => {
    state.customerConfig = config
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
